module.exports = __webpack_public_path__ + "static/media/settings-withbackground.01a6ef9e.svg";